import { render } from "./StandDialog.vue?vue&type=template&id=a29324a4&scoped=true&ts=true"
import script from "./StandDialog.vue?vue&type=script&lang=ts"
export * from "./StandDialog.vue?vue&type=script&lang=ts"

import "./StandDialog.vue?vue&type=style&index=0&id=a29324a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-acom26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29324a4"]])

export default __exports__